module.exports = __webpack_public_path__ + "img/front_length_to_underbust.7cd4e516.png";